module.exports = __webpack_public_path__ + "img/body-3.86e85fe1.png";